export default __webpack_public_path__ + "static/media/upgrade-report11.b551565b.png";